import _ from 'lodash';

export const getParameterByName = (
  name: string,
  url: string = window.location.href
) => {
  const newName = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const isYoutubeUrl = (url: string) => {
  const p =
    /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  const matches = url.match(p);
  return !!matches;
};

export const isAbsoluteUrl = (url: string) => {
  const r = new RegExp('^(?:[a-z]+:)?//', 'i');
  return r.test(url);
};

export const joinPath = (a: string, b: string, c = '/'): string => {
  const [baseUrl, queryStringA] = a.split('?');
  const [subPath, queryStringB] = b.split('?');

  const basePath = _.trimEnd(baseUrl, '/');
  const appendedPath = _.trimStart(subPath, '/');
  let fullPath = `${basePath}${c}${appendedPath}`;

  fullPath = _.trimEnd(fullPath, '/');

  if (queryStringA && queryStringB) {
    fullPath = `${fullPath}?${queryStringA}&${queryStringB}`;
  } else if (queryStringA) {
    fullPath = `${fullPath}?${queryStringA}`;
  } else if (queryStringB) {
    fullPath = `${fullPath}?${queryStringB}`;
  }
  return fullPath;
};
